import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'components/show/TextField';
import utils from 'helpers/utils';

const DateTimeUTCTextField = (props) => {
    const {
        label,
        options,
        value,
    } = props;

    if (utils.isEmpty(value)) {
        return null;
    }

    return <TextField
        label={ label }
        value={ utils.toDateString(
            utils.createDateTime(value, true), options
        ) }
    />;
};

DateTimeUTCTextField.defaultProps = {
    options: {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    },
};

DateTimeUTCTextField.propTypes = {
    label: PropTypes.string.isRequired,
    options: PropTypes.object,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

export default DateTimeUTCTextField;



// WEBPACK FOOTER //
// ./src/components/show/DateFields/DateTimeUTCTextField.js